import { render, staticRenderFns } from "./RedEnvelope.vue?vue&type=template&id=37db2876&"
import script from "./RedEnvelope.vue?vue&type=script&lang=ts&"
export * from "./RedEnvelope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports